import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const AgeOfFlatMatesTo: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='margin-top-m palm-one-whole lap-one-half desk-one-half lap-padding-left-m desk-padding-left-m'>
      <TextInput
        id='age-of-flat-mates-to'
        propertyName='ageOfFlatMatesTo'
        label={<>{t('wizard.screen.whoWeLookFor.labels.ageOfFlatMatesTo', 'Age of requested from')}</>}
        placeholder=''
        value={insertionData.ageOfFlatMatesTo}
        type='tel'
        maxLength={3}
        errors={validationMessages?.ageOfFlatMatesTo ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default AgeOfFlatMatesTo
